<!-- =========================================================================================
    File Name: ChartBarChart.vue
    Description: Create bar chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template v-if="showadata">
  <vx-card title="Répatition de vente et achat par magasin" class="mb-base" code-toggler>
    <template slot="actions">
      <select
              name="LeaveType"
              @change="onChangeyear($event)"
              class="form-control w-32 vx-col p-0"
            >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
              <option :value="new Date().getFullYear()" selected>{{new Date().getFullYear()}}</option>
              <option :value="new Date().getFullYear()-1">{{new Date().getFullYear()-1}}</option>
            </select>
       <select name="LeaveType" @change="onChange($event)" class="form-control w-32 ml-1">
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
        <option value="1">Dernier Mois</option>
        <option value="3" selected>Dernier 3 Mois</option>
        <option value="6">Dernier 6 Mois</option>
        <option value="12">Dernier 12 Mois</option>
      </select>
    </template>
    <div slot="no-body">
      <div class="mt-5">
        <e-charts autoresize :options="bar" ref="bar" theme="ovilia-green" auto-resize />
      </div>
    </div>
  </vx-card>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import theme from "./theme.json";

ECharts.registerTheme("ovilia-green", theme);

export default {
  data() {
    return {
      showadata: false,
      bar: {
        legend: {},
        tooltip: {},
        dataset: {
          // Provide data.
          source: [
            ["Type ", "Achat", "Vente"],
            ["magasin Medenine", ...this.randomize()],
            ["Magasin Charguia", ...this.randomize()],
            ["Magasin Sidi Rzig", ...this.randomize()],
            ["Magasin XX", ...this.randomize()],
            ["MAgasin YY", ...this.randomize()]
          ]
        },
        // Declare X axis, which is a category axis, mapping
        // to the first column by default.
        xAxis: { type: "category" },
        // Declare Y axis, which is a value axis.
        yAxis: {},
        // Declare several series, each of them mapped to a
        // column of the dataset by default.
        series: [{ type: "bar" }, { type: "bar" }]
      }
    };
  },
  methods: {
    randomize() {
      this.showadata = true;
      return [
        Math.round(300 + Math.random() * 700) / 10,
        Math.round(300 + Math.random() * 700) / 10
      ];
    },
    onChange($event) {
      console.log($event.target.value);
      this.loadData($event.target.value);
    },
    onChangeyear($event) {
      console.log($event.target.value);
      this.loadData($event.target.value);
    },
    loadData(periode) {
      console.log(periode);
    }
  },
  components: {
    ECharts
  }
};
</script>
